<template>
  <div>
    <h1 class="title has-text-centered">Finalizar Evaluación</h1>
    <h2 class="subtitle has-text-centered">Revisa los resultados de la Evaluación</h2>
    <hr>
    <div class="columns is-mobile">
      <div class="column has-text-right info-line-height">
        <p class="title is-5 mb-1">Juez Evaluador</p>
        <p class="title is-5 mb-1">Secretario Evaluador</p>
        <p class="title is-5 mb-1">Lección</p>
        <p class="title is-5 mb-1">Nota Máxima</p>
        <p class="title is-5 mb-1">Hora Inicio</p>
        <p class="title is-5 mb-1">Hora Termino</p>
        <p class="title is-5 mb-1">Duración</p>
      </div>
      <div class="column has-text-left info-line-height">
        <p class="subtitle is-5 mb-1">{{judgeName}}</p>
        <p class="subtitle is-5 mb-1">{{secretaryName}}</p>
        <p class="subtitle is-5 mb-1">{{lessonName}}</p>
        <p class="subtitle is-5 mb-1">{{maxScore}}pts</p>
        <p class="subtitle is-5 mb-1">{{startAt}}</p>
        <p class="subtitle is-5 mb-1">{{endAt}}</p>
        <p class="subtitle is-5 mb-1">{{duration}}</p>
      </div>
    </div>
    <div class="columns is-mobile is-centered">
      <div class="column is-half py-0">
        <b-field grouped expanded>
          <b-field label="Observación Final"  label-position="inside" expanded>
            <b-input type="textarea" v-model="observation" expanded>
            </b-input>
          </b-field>
          <b-field label="Errores" label-position="inside">
            <b-input type="number" min="0" step="1" v-model="errors">
            </b-input>
          </b-field>
        </b-field>
      </div>
    </div>
    <hr>
    <div class="columns is-vcentered is-centered">
      <div class="column">
        <div class="level is-mobile">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Subtotal</p>
              <p class="title">{{subTotal}}pts</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Errores</p>
              <p class="title">{{errors}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Total</p>
              <p class="title">{{total}}pts</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Nota Final</p>
              <p class="title">{{finalScore}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="columns is-mobile is-centered">
      <div class="column is-two-fifths">
        <b-button type="is-default" size="is-medium" @click="editExecution" expanded>Corregir</b-button>
      </div>
      <div class="column is-two-fifths">
        <b-button type="is-success" size="is-medium" @click="finishEvaluation" expanded>Finalizar</b-button>
      </div>
    </div>
  </div>
</template>

<script>

// import EventService from '@/services/ExerciseService'

import ExecutionService from '@/services/ExecutionService'

export default {
  props: {
    scores: {
      required: false,
      type: Array,
      default: () => []
    },
    lessonId: {
      required: true
    },
    executionId: {
      required: true
    },
    lesson: {
      required: true
    },
    judges: {
      required: true
    },
    executionInfo: {
      required: true
    }
  },
  mounted () {
    this.calcTotals()
  },
  data () {
    return {
      selectedJudge: null,
      isLoading: false,
      subTotal: 0,
      total: 0,
      observation: null,
      errors: 0
    }
  },
  computed: {
    secretaryName () {
      if (!this.judges || !this.judges.secretary) return ''
      let name = this.judges.secretary.name
      let lastname = this.judges.secretary.lastname
      return `${name} ${lastname}`
    },
    judgeName () {
      if (!this.judges) return ''
      let name = this.judges.judge.name
      let lastname = this.judges.judge.lastname
      return `${name} ${lastname}`
    },
    finalScore () {
      let maxScore = this.lesson ? this.lesson.max_score : 0
      let finalScore = (this.total / parseInt(maxScore) * 100)
      return `${finalScore.toFixed(2)}%`
    },
    lessonName () {
      return this.lesson ? this.lesson.name : ''
    },
    maxScore () {
      return this.lesson ? this.lesson.max_score : 0
    },
    endAt () {
      return this.executionInfo ? this.executionInfo.end_at : ''
    },
    startAt () {
      return this.executionInfo ? this.executionInfo.start_at : ''
    },
    duration () {
      return this.executionInfo ? this.executionInfo.duration : ''
    }
  },
  methods: {
    editExecution () {
      this.$emit('go-to-back')
    },
    async finishEvaluation () {
      if (!this.judges) return false
      try {
        let data = {
          ...this.executionInfo,
          observation: this.observation,
          errors: this.errors
        }
        let judgeId = this.judges.judge.id
        let response = await ExecutionService.finishJudgeExecution(this.executionId, judgeId, data)
        if (response && response.data && response.data.data) {
          this.alert('Evaluación registrada correctamente', 'is-success')
          this.$emit('finished')
        } else {
          this.alert('No se pudo finalizar la evaluación', 'is-danger')
        }
      } catch (e) {
        this.alert('No se pudo finalizar la evaluación', 'is-danger')
      }
    },
    alert (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    calcTotals () {
      let subtotal = 0
      for (let index = 0; index < this.scores.length; index++) {
        let exercise = this.scores[index]
        if (exercise && !exercise.disabled_evaluate) {
          subtotal += (parseFloat(exercise.base_score) * parseInt(exercise.coefficient))
        }
      }
      this.subTotal = subtotal
      this.total = subtotal - parseInt(this.errors)

      // this.forceRerender()
    }
  },
  watch: {
    scores () {
      this.calcTotals()
    },
    errors () {
      this.calcTotals()
    }
  }
}
</script>

<style scope>
  .info-line-height p{
    line-height: 1.8 !important;
  }
</style>
